import { services } from '@project/API';
import { onDeleteLayers } from '@utils/deleteLayers';
import { Coordinate } from 'ol/coordinate';
import olMap from 'ol/Map';
import { LineString } from 'ol/geom';
import Feature from 'ol/Feature';
import { Vector as VectorLayer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import { Stroke, Style } from 'ol/style';
import { RouteMenu } from '@project/store/Controller';

export const createRoute = (coordinates: Coordinate[], map: olMap) => {
  const route = new LineString(coordinates);
  route.transform('EPSG:4326', map.getView().getProjection().getCode());
  const routeFeature = new Feature({
    type: 'route',
    geometry: route,
  });

  const vectorLayer = new VectorLayer({
    source: new VectorSource({ features: [routeFeature] }),
    style: new Style({
      stroke: new Stroke({
        width: 4,
        color: [40, 40, 40, 0.8],
      }),
    }),
  });
  vectorLayer.setZIndex(2);
  vectorLayer.set('_route', true);
  map.addLayer(vectorLayer);

  map.getView().fit(route.getExtent(), {
    size: map.getSize(),
    padding: [100, 50, 100, 50],
  });
};

export const makeRoute = async (
  point1: string,
  point2: string,
  vehicleType: RouteMenu,
  map: olMap,
) => {
  try {
    const point = `&point=${point1}&point=${point2}`;

    const response = await services.geolocate.get(point, vehicleType);
    onDeleteLayers('_route');
    onDeleteLayers('_geoMarker');

    if (!response.paths.length) return;

    const data: {
      points: { coordinates: Coordinate[] };
      time: number;
      distance: number;
      instructions: never[];
    } = response.paths[0];

    createRoute(data.points.coordinates, map);

    return {
      time: data.time,
      distance: data.distance,
      points: data.points.coordinates,
      instructions: data.instructions,
    };
  } catch (e) {
    throw e;
  }
};
